/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NavigationRailItem } from '../models/NavigationRailItem';
import { request as __request } from '../core/request';

export class CompanyFeaturesService {

    /**
     * Get the navigation rail for a company
     * Returns the navigation rail built from the features and sub-features enabled for the company, in display order. Each entry is either a flat link (`item`) or a collapsible group (`expansion`); exactly one of the two is set.
 * 
     * @returns NavigationRailItem Navigation rail for the company.
     * @throws ApiError
     */
    public static async getAllFeatures({
companyId,
}: {
companyId: number,
}): Promise<Array<NavigationRailItem>> {
        const result = await __request({
            method: 'GET',
            path: `/super-admin/companies/${companyId}/feature`,
            errors: {
                400: `Invalid request`,
                403: `The authenticated user is not allowed to perform this operation. They may not belong to the company in the request context or do not have sufficient permissions to perform the operation`,
                404: `The requested resource was not found`,
            },
        });
        return result.body;
    }

    /**
     * Enable a feature for a company
     * Enables the feature for the company. No request body is required. Responds with plain text.
 * 
     * @returns string Feature enabled.
     * @throws ApiError
     */
    public static async setCompanyFeature({
companyId,
featureId,
}: {
companyId: number,
/** Feature identifier. **/
featureId: number,
}): Promise<string> {
        const result = await __request({
            method: 'POST',
            path: `/super-admin/companies/${companyId}/feature/${featureId}/set`,
            errors: {
                400: `Invalid request`,
                403: `The authenticated user is not allowed to perform this operation. They may not belong to the company in the request context or do not have sufficient permissions to perform the operation`,
                404: `The requested resource was not found`,
            },
        });
        return result.body;
    }

    /**
     * Disable a feature for a company
     * Disables the feature for the company. No request body is required. Responds with plain text.
 * 
     * @returns string Feature disabled.
     * @throws ApiError
     */
    public static async disableCompanyFeature({
companyId,
featureId,
}: {
companyId: number,
/** Feature identifier. **/
featureId: number,
}): Promise<string> {
        const result = await __request({
            method: 'DELETE',
            path: `/super-admin/companies/${companyId}/feature/${featureId}/disable`,
            errors: {
                400: `Invalid request`,
                403: `The authenticated user is not allowed to perform this operation. They may not belong to the company in the request context or do not have sufficient permissions to perform the operation`,
                404: `The requested resource was not found`,
            },
        });
        return result.body;
    }

    /**
     * Get the navigation rail for a company
     * Returns the navigation rail built from the features and sub-features enabled for the company, in display order. Each entry is either a flat link (`item`) or a collapsible group (`expansion`); exactly one of the two is set.
 * 
     * @returns NavigationRailItem Navigation rail for the company.
     * @throws ApiError
     */
    public static async getCompanyFeatures({
companyId,
}: {
companyId: number,
}): Promise<Array<NavigationRailItem>> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/feature`,
            errors: {
                400: `Invalid request`,
                403: `The authenticated user is not allowed to perform this operation. They may not belong to the company in the request context or do not have sufficient permissions to perform the operation`,
                404: `The requested resource was not found`,
            },
        });
        return result.body;
    }

}